import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { text } from "@/constants/tailwind-theme";

const SectionHeaderComponent = ({
  type = "primary",
  title,
  description,
}) => {
  const isSecondary = type === "secondary";

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-row items-center gap-4">
        <h2
          className={cn(
            text.heading2,
            isSecondary ? "text-white" : "text-primary-500"
          )}
        >
          {title}
        </h2>
        <Separator
          className={cn(
            "h-1.5 w-20 rounded-sm",
            isSecondary ? "bg-white" : "bg-primary-500"
          )}
        />
      </div>
      <p
        className={cn(
          text.description1,
          isSecondary ? "text-white/90" : "text-muted-foreground"
        )}
      >
        {description}
      </p>
    </div>
  );
};

export default SectionHeaderComponent;
